import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import {
    AbstractControlOptions,
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResetPassword } from 'src/app/shared/services/auth-service/reset-password.service';
import { ApiService } from 'src/app/shared/services/api-service/api.service';
import * as CryptoJS from 'crypto-js';
import { RegexEnum } from 'src/app/shared/global/regex-enum';
@Component({
    selector: 'app-set-new-password',
    templateUrl: './set-new-password.component.html',
    styleUrls: ['./set-new-password.component.scss'],
})
export class SetNewPasswordComponent implements OnInit {
    epochNow: any;

    constructor(
    private activatedRoute: ActivatedRoute,
    private resetToken: ResetPassword,
    private formBuilder: FormBuilder,
    private reset_Password: ResetPassword,
    private snackBar: MatSnackBar,
    private router: Router,
    private apiService: ApiService
    ) {}
    getToken: any;
    getCompany: string;
    getid: string;
    errorMessage: any;

    setExpiry!: boolean;

    setDiff: any;
    public showPassword = false;
    public confirmShowPassword = false;
    setPassForm!: FormGroup;
    getUserID: any[] = [];
    getUserEmail: any[] = [];

    async ngOnInit() {
        await this.getQueryparams();
        if (this.getToken) {
            setTimeout(async () => {
                (await this.resetToken.resetVerificationTwo(this.getToken)).subscribe(
                    (res: any) => {
                        if(res[0]==400){
                            this.setExpiry = true;
                            return;
                        }
                        this.epochNow = moment(parseInt(res[0]?.data.token_expiry));
                        const epochNow = new Date().getTime();
                        this.setDiff = this.epochNow.diff(epochNow).toString();

                        if (this.setDiff < -4000000) {
                            this.setExpiry = true;
                        } else {
                            this.setExpiry = false;
                            this.getUserID.push(res[0]?.data?.id);
                            this.getUserEmail.push(res[0]?.data?.email);
                        }
                    }
                );
            }, 100);
        }
        this.resetPasswordFormInit();
    }

    resetPasswordFormInit() {
        this.setPassForm = this.formBuilder.group(
            {
                password: [
                    '',
                    [
                        Validators.required,
                        Validators.pattern(RegexEnum.passwordValidation),
                    ],
                ],
                confirmPassword: ['', [Validators.required]],
            },
      {
          validator: this.ConfirmedValidator('password', 'confirmPassword'),
      } as AbstractControlOptions
        );
    }

    async getQueryparams() {
        this.activatedRoute.queryParams.subscribe(async (params) => {
            this.getToken = params['token'];
            this.getCompany = params['company_id']?.replaceAll(' ', '+');
            this.getid = params['id']?.replaceAll(' ', '+');
        });
    }

    ConfirmedValidator(controlName: string, matchingControlName: string) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
            if (
                matchingControl.errors &&
        !matchingControl.errors['confirmedValidator']
            ) {
                return;
            }
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ confirmedValidator: true });
            } else {
                matchingControl.setErrors(null);
            }
        };
    }

    togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
    }
    toggleConfirmPasswordVisibility(): void {
        this.confirmShowPassword = !this.confirmShowPassword;
    }
    checkInput(event: any, name: any) {
        if (event.code === 'Space' && name == 'confirmPassword') {
            setTimeout(() => {
                const trimValue = this.setPassForm.value.confirmPassword.trim();
                this.setPassForm.patchValue({ ['confirmPassword']: trimValue });
            });
        }
        if (event.code === 'Space' && name == 'password') {
            setTimeout(() => {
                const trimValue = this.setPassForm.value.password.trim();
                this.setPassForm.patchValue({ ['password']: trimValue });
            });
        }
    }

    async resetPassword() {
        this.activatedRoute.queryParams.subscribe(async (params) => {
            if (this.setPassForm.invalid) {
                return this.setPassForm.markAllAsTouched();
            }

            this.getToken = params['token'];
           
            if (this.getToken) {
                const data: any = {
                    email: this.getUserEmail[0],
                    id: CryptoJS.AES.encrypt(
                        this.getUserID[0]?.toString().trim(),
                        ''
                    ).toString(),
                    password: this.setPassForm.value.password,
                };
                (await this.reset_Password.setNewPass(data)).subscribe((dataRes) => {
                    if (dataRes[0] != 400) {
                        this.router.navigate(['/password_reset_success']);
                    } 
                });
            } else {
                const data: any = {
                    id: this.getid,
                    password: this.setPassForm.value.password,
                    company_id: this.getCompany,
                };
                (await this.reset_Password.setNewPass(data)).subscribe((dataRes) => {
                    if (dataRes) {
                        this.apiService.showSuccess('Password changed successfully');
                        this.router.navigate(['/password_reset_success']);
                    } else {
                        this.apiService.showError('Something went wrong please try again');
                    }
                });
            }
        });
    }
}
